module.exports = __webpack_public_path__ + "static/media/skill-html.5c342889.png";